export const LIGHT = {
  primary: '#f15622',
  navbar: '#364a5e',
  cta: '#FBAF1A',
  text: '#364a5e',
  paper: '#FFFFFF',
};

export const DARK = {
  primary: '#f15622',
  navbar: '#364a5e',
  cta: '#FBAF1A',
  text: '#fff',
  paper: '#2f3742',
};
